import { clearSession } from '@shared/_legacy/services/SessionService';
import { Link } from '@tanstack/react-router';
import useGetGlobalSiteSettings from '@shared/features/global-site-settings/hooks/useGetGlobalSiteSettings.ts';

const NoMember = () => {
    const { loginUrl } = useGetGlobalSiteSettings();
    clearSession();
    const becomeMember = () => {
        window.location.href = '/bli-medlem'; //navigate({to: '/bli-medlem'});
    };

    return (
        <div className='main-wrapper notranslate'>
            <main
                className='main-content d-flex flex-wrap'
                role='main'
            >
                <div className='container-lg'>
                    <div className='row bg-light'>
                        <div className='col'>
                            <div className='card-login card card-body mt-4 mt-md-7 mx-auto mb-5 slide-up-fade-in'>
                                <h4 className='mb-1'>Du verkar inte vara medlem än</h4>
                                <p className='text-muted mb-4'>Vill du ansöka om medlemskap eller försöka logga in igen?</p>
                                <div className='form-group'>
                                    <button
                                        type='button'
                                        className=' btn btn-primary btn-block py-3'
                                        onClick={() => becomeMember()}
                                    >
                                        Bli medlem
                                    </button>
                                </div>
                                {loginUrl ? (
                                    <div className='form-group mb-0'>
                                        <Link
                                            type='button'
                                            className=' btn btn-light btn-block py-3'
                                            to={'/$'}
                                            params={{ _splat: loginUrl }}
                                        >
                                            Tillbaka till inloggning
                                        </Link>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default NoMember;
